/**
 * Small helpers for the live lessons payment pieces (components/LivePayment).
 */
import type { PaymentRequestPaymentMethodEvent } from '@stripe/stripe-js';
import type { PaidWith } from '../components/LivePayment';

export function paidWithLabel(p: PaidWith): string {
  if (p.kind === 'apple_pay') return 'Apple Pay';
  if (p.kind === 'card') return 'Card';
  return `${p.card.brand.charAt(0).toUpperCase()}${p.card.brand.slice(1)} •••• ${p.card.last4}`;
}

/**
 * Closes the wallet's sheet once, success or fail, however the flow after
 * it ends.
 */
export function walletCloser(ev: PaymentRequestPaymentMethodEvent) {
  let open = true;
  return (status: 'success' | 'fail') => {
    if (open) { open = false; ev.complete(status); }
  };
}
